// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Conteneur de l'image : repère des bulles, qui suivent ainsi l'image au défilement */
.secret_wrapper {
    position: relative;
    display: inline-block;
    vertical-align: top;
}

.secret_img {
    display: block;
    max-width: 90vw;
    max-height: 90vh;
    width: auto;
    height: auto;
}

/* Bulle ouverte au point cliqué ; ETome2 la décale si elle sort de la fenêtre */
.speech-bubble {
    position: absolute;
    background: #fff;
    border: 2px solid #000;
    border-radius: 0.4em;
    padding: 10px 20px;
    /* largeur du texte, sans être écrasée par le bord droit de l'image */
    width: max-content;
    max-width: min(90vw, 32em);
    text-align: center;
    font-size: 1.2em;
    color: #000;
    z-index: 1000;
    box-sizing: border-box;
    overflow-wrap: break-word;
    white-space: normal;
    cursor: pointer;
}

.speech-bubble p {
    margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/css/EnigmeTome2.css"],"names":[],"mappings":"AAAA,sFAAsF;AACtF;IACI,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA,gFAAgF;AAChF;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB,qEAAqE;IACrE,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,SAAS;AACb","sourcesContent":["/* Conteneur de l'image : repère des bulles, qui suivent ainsi l'image au défilement */\n.secret_wrapper {\n    position: relative;\n    display: inline-block;\n    vertical-align: top;\n}\n\n.secret_img {\n    display: block;\n    max-width: 90vw;\n    max-height: 90vh;\n    width: auto;\n    height: auto;\n}\n\n/* Bulle ouverte au point cliqué ; ETome2 la décale si elle sort de la fenêtre */\n.speech-bubble {\n    position: absolute;\n    background: #fff;\n    border: 2px solid #000;\n    border-radius: 0.4em;\n    padding: 10px 20px;\n    /* largeur du texte, sans être écrasée par le bord droit de l'image */\n    width: max-content;\n    max-width: min(90vw, 32em);\n    text-align: center;\n    font-size: 1.2em;\n    color: #000;\n    z-index: 1000;\n    box-sizing: border-box;\n    overflow-wrap: break-word;\n    white-space: normal;\n    cursor: pointer;\n}\n\n.speech-bubble p {\n    margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
